import { Link } from "react-router-dom";
import { ArrowLeft, MessageSquare } from "lucide-react";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";
import { PentominoMark } from "../components/pt/PentominoMark";

const ComingSoon = ({ pageKey = "generic" }) => {
    const { t, waUrl } = useLang();
    const navLabel = t.nav[pageKey] || t.comingSoon.title;

    return (
        <section
            className="sec relative overflow-hidden bg-niebla"
            data-testid={`coming-soon-${pageKey}`}
        >
            <div className="wrap grid items-center gap-16 lg:grid-cols-2">
                <div>
                    <div className="pt-eyebrow mb-5">
                        <span className="dot" />
                        <span>{t.comingSoon.tag}</span>
                    </div>
                    <div className="mb-3 text-sm font-semibold uppercase tracking-widest text-acero">
                        {navLabel}
                    </div>
                    <h1 className="h1 max-w-[20ch]">{t.comingSoon.title}</h1>
                    <p className="lead mt-5">{t.comingSoon.lead}</p>
                    <div className="mt-10 flex flex-wrap gap-3">
                        <Link
                            to="/"
                            className="pt-btn alt"
                            data-testid="coming-soon-back"
                        >
                            <ArrowLeft size={16} />
                            {t.comingSoon.back}
                        </Link>
                        <a
                            href={waUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="pt-btn"
                            data-testid="coming-soon-whatsapp"
                        >
                            <MessageSquare size={16} />
                            {t.comingSoon.whatsapp}
                        </a>
                    </div>
                </div>
                <motion.div
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.8 }}
                    className="flex justify-center lg:justify-end"
                >
                    <PentominoMark size={300} />
                </motion.div>
            </div>
        </section>
    );
};

export default ComingSoon;
